import { useState, useCallback, type FC } from 'react';

import { CollapsibleListSectionContent } from '../collapsible-list-section-content';
import { CollapsibleListSectionHeader } from '../collapsible-list-section-header';

import { CollapsibleListSection } from './index';

import type { UncontrolledCollapsibleListSectionProps } from './collapsible-list-section-types';

export const UncontrolledCollapsibleListSection: FC<UncontrolledCollapsibleListSectionProps> = ({
  className,
  theme,
  alwaysOpen = false,
  headerClassName,
  noIcon = false,
  initiallyClosed = false,
  header,
  children,
}) => {
  const [open, setOpen] = useState(!initiallyClosed);

  const toggleCollapsed = useCallback(() => {
    if (alwaysOpen) {
      return;
    }
    setOpen(!open);
  }, [alwaysOpen, setOpen, open]);

  return (
    <CollapsibleListSection className={className} open={alwaysOpen || open}>
      <CollapsibleListSectionHeader className={headerClassName} noIcon={noIcon} onClick={toggleCollapsed} theme={theme}>
        {header}
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>{children}</CollapsibleListSectionContent>
    </CollapsibleListSection>
  );
};
